import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {DietaryIndicatorSearchModel} from "../dietary-indicator-search.model";
import {
    DietaryIndicatorSearchPageComponent
} from "../dietary-indicator-search-page/dietary-indicator-search-page.component";
import {DietaryIndicatorEditPageComponent} from "../dietary-indicator-edit-page/dietary-indicator-edit-page.component";

@Component({
    selector: "wbo-dietary-indicator-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(DietaryIndicatorMultiSelectEditControlComponent),
        provideSearchModel(DietaryIndicatorSearchModel)
    ]
})
export class DietaryIndicatorMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<DietaryIndicatorSearchModel> {
    constructor(model: DietaryIndicatorSearchModel, injector: Injector) {
        super(model, injector, "id", "description");
        this.labelSearchField = "code";
        this.summaryLabelField = "code";

        this.extendedSearchComponent = DietaryIndicatorSearchPageComponent;
        this.extendedEditComponent = DietaryIndicatorEditPageComponent;
    }
}
